import { motion } from "framer-motion";
import { ArrowRight, ImagePlus, Lightbulb, Flag, PenTool, CheckCircle2 } from "lucide-react";

const rise = { hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } } };
const Sec = ({ children, testid }) => (
  <motion.section className="pj-sec" data-testid={testid} variants={rise} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-40px" }}>
    {children}
  </motion.section>
);

export const CaseStudy = ({ p }) => (
  <>
    <Sec testid="project-challenge">
      <div className="eyebrow"><Flag className="icon" style={{ width: 12, height: 12 }} /> The challenge</div>
      <p className="pj-lead">{p.challenge}</p>
    </Sec>

    <Sec testid="project-timeline">
      <div className="eyebrow">Progress timeline</div>
      <h2 className="pj-h2">From research to launch.</h2>
      <div className="pj-timeline">
        {p.timeline.map((t, i) => (
          <div className="pj-tl-stage" key={i}>
            <div className="pj-tl-dot"></div>
            <div className="pj-tl-label">{t.label}</div>
            <div className="pj-tl-period">{t.period}</div>
            <div className="pj-tl-desc">{t.desc}</div>
          </div>
        ))}
      </div>
    </Sec>

    <Sec testid="project-process">
      <div className="eyebrow"><PenTool className="icon" style={{ width: 12, height: 12 }} /> My process</div>
      <h2 className="pj-h2">How the work took shape.</h2>
      <div className="pj-process-grid">
        <div>
          {p.process.map((para, i) => <p className="pj-body" key={i}>{para}</p>)}
        </div>
        <div className="pj-media-stack">
          <div className="pj-media-slot" data-testid="process-media-slot-1">
            <ImagePlus className="icon" />
            <span>Sketch / early draft</span>
            <em>Space reserved for working sketches and drafts</em>
          </div>
          <div className="pj-media-slot" data-testid="process-media-slot-2">
            <ImagePlus className="icon" />
            <span>Work-in-progress</span>
            <em>Screenshots, storyboards, prototypes</em>
          </div>
        </div>
      </div>
    </Sec>

    <Sec testid="project-comparison">
      <div className="eyebrow">Side by side</div>
      <h2 className="pj-h2">Rough draft → final form.</h2>
      <div className="pj-compare">
        <div className="pj-compare-panel before">
          <div className="pj-compare-badge">Before</div>
          <div className="pj-media-slot small"><ImagePlus className="icon" /><span>Rough sketch</span></div>
          <div className="pj-compare-title">{p.comparison.before.title}</div>
          <p className="pj-compare-body">{p.comparison.before.body}</p>
        </div>
        <div className="pj-compare-arrow"><ArrowRight className="icon" /></div>
        <div className="pj-compare-panel after">
          <div className="pj-compare-badge">After</div>
          <div className="pj-media-slot small"><ImagePlus className="icon" /><span>Final polished work</span></div>
          <div className="pj-compare-title">{p.comparison.after.title}</div>
          <p className="pj-compare-body">{p.comparison.after.body}</p>
        </div>
      </div>
    </Sec>

    <Sec testid="project-result">
      <div className="eyebrow"><CheckCircle2 className="icon" style={{ width: 12, height: 12 }} /> The final result</div>
      <p className="pj-lead">{p.resultIntro}</p>
      <div className="pj-stats">
        {p.resultStats.map(([n, l], i) => (
          <div className="stat-card" key={i}><div className="sc-num">{n}</div><div className="sc-lbl">{l}</div></div>
        ))}
      </div>
    </Sec>

    <Sec testid="project-lesson">
      <div className="pj-lesson">
        <div className="pj-lesson-icon"><Lightbulb className="icon" /></div>
        <div>
          <div className="pj-lesson-title">Lessons learned</div>
          <p className="pj-lesson-body">{p.lesson}</p>
        </div>
      </div>
    </Sec>
  </>
);
